function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 5,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00999a"
    },
    fillRule: "evenodd",
    d: "M27.551 4.996c-1.352 0-2.447-1.117-2.447-2.496S26.199.002 27.551.002c1.351 0 2.446 1.119 2.446 2.498 0 1.379-1.095 2.496-2.446 2.496zm-12.552 0c-1.351 0-2.447-1.117-2.447-2.496S13.648.002 14.999.002s2.448 1.119 2.448 2.498c0 1.379-1.097 2.496-2.448 2.496zm-12.55 0C1.098 4.996.003 3.879.003 2.5S1.098.002 2.449.002c1.353 0 2.448 1.119 2.448 2.498 0 1.379-1.095 2.496-2.448 2.496z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMore);
export default __webpack_public_path__ + "static/media/ico-more.495940f24b06d031a06f8f0e11f19b32.svg";
export { ForwardRef as ReactComponent };